import { HttpBaseApi } from '@forto-dev/ui-platform-http'
import { HttpBaseApiWrapper } from 'service/HttpBaseApiWrapper'
import { getAPIBaseUrl } from 'service/url'

export type TGet<T> = (id: string) => Promise<T>
export async function get(this: IApiService, id: string) {
  const response = await HttpBaseApi.get(getAPIBaseUrl(`${this.endpoint}/${id}`))
  return response.data
}

export interface IApiServiceProps {
  httpAPI: HttpBaseApiWrapper
}

export interface IApiService {
  httpAPI: HttpBaseApiWrapper
  endpoint: string
}
